export const ARTIST_BIO_MAX_CHARACTERS = 500;
